export const LabsDocsLink = {
  label: 'Docs',
  href: 'https://docs.fission.xyz',
}
